module.exports = __webpack_public_path__ + "static/media/18_plantilla_rec_combo_simple_cp_stills_tetra_200_ades_nar.58bf3984.png";